









import { Component, Prop, Vue } from 'vue-property-decorator';
import mdbWysiwygToolbar from '@folky-tools/mdb-wysiwyg/src/components/mdbWysiwygToolbar.vue';
import WysiwygTextarea from './WysiwygTextarea.vue';

@Component({
    components: {
        mdbWysiwygToolbar,
        WysiwygTextarea
    }
})
export default class Wysiwyg extends Vue {
    @Prop({ type: String, default: '' })
    private htmlContent?: string;
    private activeView: string = 'html';
    private commandState: any = {
        bold: false,
        italic: false,
        strikeThrough: false,
        underline: false,
        justifyLeft: true,
        justifyCenter: false,
        justifyRight: false,
        justifyFull: false
    };
    private textState: string = 'p';
    private translations: any = {};

    private colors: string[] = [
        '#EA3C3B',
        '#E00065',
        '#9C00B0',
        '#7000B7',
        '#533CB4',
        '#5587F4',
        '#509EF4',
        '#46B9D3',
        '#2E9786',
        '#4FB54E',
        '#87CA47',
        '#C4E534',
        '#DFDFDF',
        '#F5C700',
        '#F49B00',
        '#F45429',
        '#75564A',
        '#9D9C9D',
        '#657B8A',
        '#4B506E',
        '#FFFFFF',
        '#000000'
    ];
    private tooltips: boolean = true;

    private changeView(view: string) {
        this.activeView = view;
    }

    private updateState(type: any, value: any) {
        this.commandState[type] = value;
    }

    private updateTextState(value: string) {
        this.textState = value;
    }

    private updateHtmlContent(value: string) {
        this.$emit('updateHtmlContent', value);
    }

    private mounted(): void {
        this.translations = {
            paragraph: this.$t('components.shared.wysiwyg.paragraph'),
            heading: this.$t('components.shared.wysiwyg.heading'),
            preformatted: this.$t('components.shared.wysiwyg.preformatted'),
            bold: this.$t('components.shared.wysiwyg.bold'),
            italic: this.$t('components.shared.wysiwyg.italic'),
            strikethrough: this.$t('components.shared.wysiwyg.strikethrough'),
            underline: this.$t('components.shared.wysiwyg.underline'),
            textcolor: this.$t('components.shared.wysiwyg.textcolor'),
            alignleft: this.$t('components.shared.wysiwyg.alignleft'),
            aligncenter: this.$t('components.shared.wysiwyg.aligncenter'),
            alignright: this.$t('components.shared.wysiwyg.alignright'),
            alignjustify: this.$t('components.shared.wysiwyg.alignjustify'),
            insertlink: this.$t('components.shared.wysiwyg.insertlink'),
            insertpicture: this.$t('components.shared.wysiwyg.insertpicture'),
            bulletlist: this.$t('components.shared.wysiwyg.bulletlist'),
            numberedlist: this.$t('components.shared.wysiwyg.numberedlist'),
            enterurl: this.$t('components.shared.wysiwyg.enterurl'),
            imageurl: this.$t('components.shared.wysiwyg.imageurl'),
            changeview: this.$t('components.shared.wysiwyg.changeview')
        };
    }
}
